import { useState } from 'react';
import { useNumericMenu, useRange } from 'react-instantsearch';
import { useTranslation } from 'next-i18next';

import styles from './PriceRefinement.module.scss';

export type PriceRefinementProps = {
  attribute: string;
  locale?: string;
};

const PriceRefinement = ({ attribute, locale }: PriceRefinementProps) => {
  const { t } = useTranslation('searchResults');

  const { items, refine: refineBucket } = useNumericMenu({
    attribute,
    items: [
      { label: t('numericMenu.1.all') },
      { label: t('numericMenu.2.under25'), start: 0, end: 25 },
      { label: t('numericMenu.3.25to50'), start: 25, end: 50 },
      { label: t('numericMenu.4.50to100'), start: 50, end: 100 },
      { label: t('numericMenu.5.100to200'), start: 100, end: 200 },
      { label: t('numericMenu.6.200to500'), start: 200, end: 500 },
      { label: t('numericMenu.7.500to1000'), start: 500, end: 1000 },
      { label: t('numericMenu.8.1000to2500'), start: 1000, end: 2500 },
      { label: t('numericMenu.9.2500&Up'), start: 2500 },
    ],
  });

  const {
    start,
    range,
    canRefine,
    refine: refineRange,
  } = useRange({ attribute });

  const boundsMin = range.min ?? 0;
  const boundsMax = range.max ?? 0;
  const refinedFrom = Number.isFinite(start[0])
    ? (start[0] as number)
    : boundsMin;
  const refinedTo = Number.isFinite(start[1])
    ? (start[1] as number)
    : boundsMax;

  const [values, setValues] = useState<[number, number]>([
    refinedFrom,
    refinedTo,
  ]);
  const [prev, setPrev] = useState<[number, number]>([refinedFrom, refinedTo]);
  if (prev[0] !== refinedFrom || prev[1] !== refinedTo) {
    setValues([refinedFrom, refinedTo]);
    setPrev([refinedFrom, refinedTo]);
  }

  const span = boundsMax - boundsMin || 1;
  const minPct = ((values[0] - boundsMin) / span) * 100;
  const maxPct = ((values[1] - boundsMin) / span) * 100;

  const handleMin = (value: number) =>
    setValues(([, hi]) => [Math.min(value, hi), hi]);
  const handleMax = (value: number) =>
    setValues(([lo]) => [lo, Math.max(value, lo)]);

  const commit = () => refineRange([values[0], values[1]]);

  const formatPrice = (value: number) =>
    new Intl.NumberFormat(`${locale ?? 'en'}-CA`, {
      style: 'currency',
      currency: 'CAD',
      maximumFractionDigits: 0,
    }).format(Math.round(value));

  return (
    <div className={styles.root}>
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.label} className={styles.item}>
            <label className={styles.label}>
              <input
                type="radio"
                name={`price-bucket-${attribute}`}
                className={styles.checkbox}
                checked={item.isRefined}
                onChange={() => refineBucket(item.value)}
              />
              <span className={styles.labelText}>{item.label}</span>
            </label>
          </li>
        ))}
      </ul>

      {/* <div className={styles.slider}>
      //removing the slider as it is not working
        <div
          className={styles.track}
          style={
            {
              '--price-min-pct': `${minPct}%`,
              '--price-max-pct': `${maxPct}%`,
            } as React.CSSProperties
          }
        >
          <span className={styles.fill} aria-hidden="true" />
          <input
            type="range"
            className={`${styles.thumb} ${styles.thumbMin}`}
            min={boundsMin}
            max={boundsMax}
            step={1}
            value={values[0]}
            disabled={!canRefine}
            aria-label={t('priceSlider.minLabel')}
            onChange={(e) => handleMin(Number(e.currentTarget.value))}
            onPointerUp={commit}
            onKeyUp={commit}
          />
          <input
            type="range"
            className={`${styles.thumb} ${styles.thumbMax}`}
            min={boundsMin}
            max={boundsMax}
            step={1}
            value={values[1]}
            disabled={!canRefine}
            aria-label={t('priceSlider.maxLabel')}
            onChange={(e) => handleMax(Number(e.currentTarget.value))}
            onPointerUp={commit}
            onKeyUp={commit}
          />
        </div>
        <div className={styles.levels}>
          <span className={styles.level}>{formatPrice(values[0])}</span>
          <span className={styles.level}>{formatPrice(values[1])}</span>
        </div>
      </div> */}
    </div>
  );
};

export default PriceRefinement;
